import { motion } from 'motion/react';
import Image from 'next/image';
import { type JSX } from 'react';

export type CardState = {
    x: string;
    y: string;
    rotate: number;
    scale?: number;
};

export type Card = {
    src: string;
    alt: string;
    side: -1 | 0 | 1;
    width: number;
    height: number;
    top: number;
    axisOffset: number;
    zIndex: number;
    resting: CardState;
    hover: CardState;
};

type Frame = { width: number; height: number };

function toPercent(value: number, base: number): string {
    return `${(value / base) * 100}%`;
}

export function CardLayer({ card, isHovered, frame }: { card: Card; isHovered: boolean; frame: Frame }): JSX.Element {
    // (frame center) + (signed offset from axis) − (half the card width)
    const left = frame.width / 2 + card.side * card.axisOffset - card.width / 2;

    return (
        <motion.div
            className="absolute origin-[50%_80%]"
            style={{
                left: toPercent(left, frame.width),
                top: toPercent(card.top, frame.height),
                width: toPercent(card.width, frame.width),
                height: toPercent(card.height, frame.height),
                zIndex: card.zIndex,
            }}
            initial={false}
            animate={isHovered ? card.hover : card.resting}
            transition={{ type: 'spring', stiffness: 220, damping: 18, mass: 0.8 }}
        >
            <div className="relative size-full rounded-[14px] overflow-hidden">
                <Image
                    src={card.src}
                    alt={card.alt}
                    fill
                    sizes="320px"
                    priority
                    className="object-cover"
                    draggable={false}
                />
            </div>
        </motion.div>
    );
}
